import ScrollReveal from "./ScrollReveal";

const WhyChooseUs = () => (
  <section id="pricing" className="py-24 px-4">
    <div className="max-w-4xl mx-auto text-center">
      <ScrollReveal>
        <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-8">Why Choose Us?</h2>
      </ScrollReveal>
      <ScrollReveal delay={0.1}>
        <p className="text-muted-foreground text-lg leading-relaxed">
          Our market research indicates that real estate agents typically invest{" "}
          <span className="text-primary font-bold text-2xl">15-20 hours</span>{" "}
          in transaction management. We believe your expertise is best utilized in selling real estate, engaging with prospects, and drafting contracts. Allow us to handle the transaction management, enabling you to focus on what you do best.
        </p>
      </ScrollReveal>
    </div>
  </section>
);

export default WhyChooseUs;
